(function ($) {
    'use strict';
    $(document).ready(function () {
        /**
         * @link http://www.chartjs.org
         */

        if (!window.Chart) {
            return;
        }

        var canvas = $("#taxon_ranking_chart,#product_variant_ranking_chart");
        if (!canvas.length) {
            return;
        }

        var data = canvas.data('json');

        var ctx = canvas[0].getContext('2d');

        window.chartColors = {
            black: "rgba(0, 0, 0, 0.9)",
            blue: "rgba(132, 99, 255, 0.2)"
        };

        var random255 = function () {
            console.log(Math.round(Math.random() * 255));
            return Math.round(Math.random() * 255);
        };

        var datasets = [];
        for (var taxonName in data.totals) {
            var totals = data.totals[taxonName];

            var color = "rgba(" + random255() + ", " + random255() + ", " + random255() + ", 0.7)";

            datasets.push({
                label: taxonName,
                backgroundColor: color,
                borderColor: window.chartColors.red,
                borderWidth: 1,
                data: totals
            });
        }

        window.myBar = new Chart(ctx, {
            type: 'bar',
            data: {
                labels: data.labels,
                datasets: datasets
            },
            options: {
                responsive: false,
                // maintainAspectRatio: false,
                legend: {
                    position: 'top'
                },
                title: {
                    display: false,
                    text: 'Product ranking'
                }
            }


        });
    });
})(jQuery);

(function ($) {
    'use strict';
    $(document).ready(function () {
        /**
         * @link http://www.chartjs.org
         */

        if (!window.Chart) {
            return;
        }

        var canvas = $("#product_ranking_chart");
        if (!canvas.length) {
            return;
        }

        var data = canvas.data('json');

        var ctx = canvas[0].getContext('2d');

        window.chartColors = {
            black: "rgba(0, 0, 0, 0.9)",
            blue: "rgba(132, 99, 255, 0.2)"
        };

        var random255 = function () {
            console.log(Math.round(Math.random() * 255));
            return Math.round(Math.random() * 255);
        };

        var labels = data.labels;

        var dataset = {label: 'Sales', data: [], backgroundColor: [], borderColor: [], borderWidth: 1};
        for (var taxonName in data.totals) {
            var total = data.totals[taxonName];

            var color = "rgba(" + random255() + ", " + random255() + ", " + random255() + ", 0.7)";

            dataset.data.push(total.toFixed(2));
            dataset.backgroundColor.push(color);
            dataset.borderColor.push(color);
        }
        var datasets = [dataset];
        console.log(data.labels);
        console.log(datasets);

        window.myBar = new Chart(ctx, {
          type: 'horizontalBar',
          // data: {
          //     labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
          //     datasets: [{
          //         label: '# of Votes',
          //         data: [12, 19, 3, 5, 2, 3],
          //         backgroundColor: [
          //             'rgba(255, 99, 132, 0.2)',
          //             'rgba(54, 162, 235, 0.2)',
          //             'rgba(255, 206, 86, 0.2)',
          //             'rgba(75, 192, 192, 0.2)',
          //             'rgba(153, 102, 255, 0.2)',
          //             'rgba(255, 159, 64, 0.2)'
          //         ],
          //         borderColor: [
          //             'rgba(255, 99, 132, 1)',
          //             'rgba(54, 162, 235, 1)',
          //             'rgba(255, 206, 86, 1)',
          //             'rgba(75, 192, 192, 1)',
          //             'rgba(153, 102, 255, 1)',
          //             'rgba(255, 159, 64, 1)'
          //         ],
          //         borderWidth: 1
          //     }]
          // },
          data: {
              labels: labels,
              datasets: datasets
          },
          options: {
              responsive: true,
              // maintainAspectRatio: false,
              // legend: {
              //     position: 'top'
              // },
              title: {
                  display: false,
                  text: 'Product ranking'
              }
          }


        });
    });
})(jQuery);

